import axios from 'axios'
import { router, store } from '../main'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import host from '../common/serverHost'

import qs from "qs"
import { initWebSocket, closeWebsocket } from "../util/socket"
axios.defaults.baseURL = host


// 请求超时
axios.defaults.timeout = 60000
// post 请求头
axios.defaults.headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
// axios.defaults.headers.post = {
//   'Content-Type': 'multipart/form-data'
// }


var axiosTimes = 0 // 定义一个变量控制axios
// axios 请求拦截器
axios.interceptors.request.use(config => {
  axiosTimes++
  // 为请求头添加 token
  config.headers['Authorization'] = localStorage.getItem('accessToken')

  // config.headers['referer'] = '127.0.0.1'


  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})


// 是否正在刷新的标记
let isRefreshing = true
// 重试队列，每一项将是一个待执行的函数形式
let requests = []


// axios 响应拦截器
axios.interceptors.response.use(response => {

  let code = response.data.code
  let msg = response.data.message
  // 200 500 401 402权限不足
  // 401 accessToken过期
  let config = response.config
  if (code == 401) {
    localStorage.setItem("close", 2)
    closeWebsocket()
    // let config = response.config
    // console.log("进入401")
    if (isRefreshing) {
      isRefreshing = true
      let payLoad = {
        accessToken: localStorage.getItem('accessToken'),
        refreshToken: localStorage.getItem('refreshToken')
      }
      payLoad = qs.stringify(payLoad);
      // console.log(payLoad, 77777777777)
      let backtoLoginFlag = false
      console.log('accessToken过期咯')
      return refreshToken(payLoad).then(res => {
        // console.log('res', res)

        if (res.code == 200) {
          console.log('accessToken过期refreshToken没有过期')
          let token = {
            accessToken: res.data.accessToken,
            refreshToken: res.data.refreshToken,
          }
          store.dispatch("setSocket", res.data.accessToken);

          // console.log('这里的token到底是什么', token, 123)
          // axios.defaults.headers['access_token'] = token.accessToken
          axios.defaults.headers['Authorization'] = token.accessToken
          window.localStorage.setItem('accessToken', token.accessToken)
          window.localStorage.setItem('refreshToken', token.refreshToken)

          // config.headers['access_token'] = token.accessToken
          // config.baseURL = host
          // config.headers['access_token'] = token.accessToken
          config.headers['Authorization'] = token.accessToken
          // 开始执行装在websocket
          initWebSocket();
          config.baseURL = host
          requests.forEach(cb => cb(token))
          requests = []
          return axios(config)
        } else {
          console.log('accessToken过期refreshToken过期')
          backtoLoginFlag = true
          // 如果当前页面不是登录页的话，跳转至登录页。如果是的话，就刷新就可以了，避免反复刷新
          if (window.location.href.indexOf('/login') == -1) {
            // window.location.href = '/login'
            // this.$router.push("/login");
            localStorage.clear()
            localStorage.removeItem("refreshToken")
            localStorage.removeItem("accessToken")
            localStorage.removeItem("socketFlg")
            window.location.reload()

          } else {
            //   // window.location.reload()
          }
          // console.log(123)

          return false
        }
      }).catch((err) => {
        console.log(err)
      })

    } else {
      isRefreshing = false
      console.log("进入else")
      return new Promise((resolve) => {
        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        requests.push((token) => {
          config.baseURL = ''
          // config.headers['access_token'] = token.accessToken
          config.headers['accessToken'] = token.accessToken

          resolve(axios(config))
        })
      })
    }


  } else if (code == 403) {
    Message({
      showClose: true,
      message: '登录过期，请重新登录！',
      duration: 1000,
      type: 'warning'
    })
    // 清除 token 和权限数组
    // localStorage.clear()
    localStorage.removeItem("refreshToken")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("socketFlg")
    store.dispatch('removeToken', null)
    store.dispatch('clearPermissions', null)
    // 跳转至登录页面，并将要浏览的页面 fullPath 传过去，登录成功后跳转需要访问的页面
    setTimeout(() => {
      router.replace({
        path: '/login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }, 1000)
  } else if (code == 404) {
    Message({
      showClose: true,
      message: '网络请求不存在！',
      duration: 1000,
      type: 'error'
    })
  } else if (code == 500) {
    // token格式错误 返回登录
    Message({
      showClose: true,
      message: msg,
      duration: 1000,
      type: 'error'
    })
  } else if (code == 402) {
    Message({
      showClose: true,
      message: '您没有权限访问这个接口！',
      duration: 1000,
      type: 'error'
    })
  }

  // 判断axios是否请求完毕
  axiosTimes--
  if (axiosTimes === 0) {
  }
  return response
}, err => {
  console.log(err, 222)
  return Promise.reject(err)
})

function refreshToken(payLoad) {
  const awsAxios = axios.create({
    transformRequest: (data, headers) => {
      return data;
    }
  });

  // instance是当前request.js中已创建的axios实例
  return awsAxios.post('/staff/refresh', payLoad).then(res =>
    res.data
  )
}

export { axios, NProgress }



// WEBPACK FOOTER //
// ./src/apiConfig/request.js